import styled from '@emotion/styled'

const StyledLabel = styled.div`
  display: inline-block;
  height: 36px;
  line-height: 36px;
  /* border:1px solid pink; */
  color: ${(props) => {
    const { color } = props
    return color
  }};
`
export default StyledLabel
